/**
 * Action-required notice for hubs where users may be on the wrong tab.
 * Prefer `actions` for custom chips; transfer hubs may pass outgoing/incoming summary.
 */

import React from 'react';

const TransferActionBanner = ({
  summary,
  onSelectDirection,
  outgoingLabel = 'Outgoing',
  incomingLabel = 'Incoming',
  actions,
  onSelectAction,
}) => {
  const resolvedActions =
    actions ||
    [
      {
        key: 'outgoing',
        label: outgoingLabel,
        count: summary?.outgoing || 0,
      },
      {
        key: 'incoming',
        label: incomingLabel,
        count: summary?.incoming || 0,
      },
    ].filter((action) => action.count > 0);

  const total =
    summary?.total ??
    resolvedActions.reduce((sum, action) => sum + (action.count || 0), 0);

  if (!total || resolvedActions.length === 0) return null;

  const itemWord = total === 1 ? 'item' : 'items';
  const handleSelect = onSelectAction || onSelectDirection;

  return (
    <div className="transfer-action-banner" role="status" aria-live="polite">
      <span className="transfer-action-banner__icon" aria-hidden="true">
        ⚡
      </span>
      <div className="transfer-action-banner__body">
        <span className="transfer-action-banner__title">
          You have {total} {itemWord} needing action
        </span>
        <div className="transfer-action-banner__chips">
          {resolvedActions.map((action) => (
            <button
              key={action.key}
              type="button"
              className="transfer-action-banner__chip"
              onClick={() => handleSelect?.(action.key)}
            >
              {action.label} ({action.count})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransferActionBanner;
